import { Link } from "wouter";
import logoColor from "../assets/logo-color-blanco.svg";
import { useEffect, useState, useRef } from "react";

// Importar las imágenes de los colaboradores
import mercyCorps from "../assets/partners/mercy-corps.png";
import partnersInHealth from "../assets/partners/partners-in-health.png";
import wwf from "../assets/partners/wwf.png";

// Nuevo componente para el mapa
function LocationMap({ mapUrl, title }: { mapUrl: string; title: string }) {
  return (
    <iframe
      src={mapUrl}
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title={title}
    ></iframe>
  );
}

export default function Footer() {
  const sectors = [
    { name: "Cárnico", href: "/sectores/carnico" },
    { name: "Conservero", href: "/sectores/conservero" },
    { name: "Horeca", href: "/sectores/horeca" },
    { name: "Lácteo", href: "/sectores/lacteo" },
    { name: "Frutas y Hortalizas", href: "/sectores/frutas-hortalizas" },
    { name: "Panadero", href: "/sectores/panadero" },
    { name: "Packaging - Envasado", href: "/sectores/packaging-envasado" },
    { name: "Vehículos y Transporte", href: "/sectores/vehiculos-transporte" },
    { name: "Varios", href: "/sectores/varios" },
  ];

  const links = [
    { name: "Trabaje con nosotros", href: "/trabaje-con-nosotros" },
    { name: "Visítanos", href: "/visitanos" },
    { name: "Piensa en Verde", href: "/piensa-en-verde" },
    //{ name: "Opiniones Innotec Food", href: "/opiniones" },
    { name: "Contacto", href: "/contacto" },
  ];

  const legalLinks = [
    { name: "Aviso legal", href: "/aviso-legal" },
    { name: "Política de privacidad", href: "/politica-privacidad" },
    { name: "Política de cookies", href: "/politica-cookies" },
    { name: "Garantía", href: "/garantia" },
    { name: "Condiciones generales", href: "/condiciones-generales" },
    { name: "Conciliación previa", href: "/conciliacion-previa" },
  ];

  const socialLinks = [
    { name: "Facebook", icon: "M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z", href: "https://facebook.com/innotecfood" },
    { name: "Instagram", icon: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z", href: "https://instagram.com/innotecfood" },
    { name: "YouTube", icon: "M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z", href: "https://youtube.com/innotecfood" },
    { name: "LinkedIn", icon: "M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z", href: "https://linkedin.com/company/innotecfood" },
    { name: "Twitter", icon: "M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z", href: "https://twitter.com/innotecfood" },
  ];

  const locations = [
    {
      name: "Oficinas (Madrid)",
      address: "Paseo de la Castellana 259C, planta 18",
      city: "28046, Madrid (España)",
      phone: "",
      mapUrl: "https://maps.google.com/maps?q=Paseo+de+la+Castellana+259C,+Madrid&t=&z=13&ie=UTF8&iwloc=&output=embed"
    },
    {
      name: "Centro de reacondicionado / Exposición zona norte (Venta de Baños)",
      address: "Calle Tren Ter, 199",
      city: "34200 Venta de Baños (Palencia)",
      company: "INNOTEC FOOD EQUIPMENT S.L.",
      phone: "",
      mapUrl: "https://maps.google.com/maps?q=Calle+Tren+Ter+199,+34200+Venta+de+Baños,+Palencia&t=&z=13&ie=UTF8&iwloc=&output=embed"
    },
    {
      name: "Almacén N-620",
      address: "Ctra. N-620 Palencia a Valladolid, Km 4,5 (Naves 5 y 7)",
      city: "34190 Villamuriel de Cerrato (Palencia)",
      company: "",
      phone: "",
      mapUrl: "https://maps.google.com/maps?q=Ctra+N620+Palencia+a+Valladolid+Km+4,5,+34190+Villamuriel+de+Cerrato&t=&z=13&ie=UTF8&iwloc=&output=embed"
    },
    {
      name: "Almacén N-611",
      address: "Carretera Nacional 611, Km 2 (Nave 11)",
      city: "34190 Villamuriel de Cerrato (Palencia)",
      company: "",
      phone: "",
      mapUrl: "https://maps.google.com/maps?q=Carretera+Nacional+611+km+2,+34190+Villamuriel+de+Cerrato&t=&z=13&ie=UTF8&iwloc=&output=embed"
    }
  ];

  const [activeLocation, setActiveLocation] = useState(0);
  const [isMapExpanded, setIsMapExpanded] = useState(false);
  const mapRef = useRef<HTMLDivElement>(null);

  // Función para cerrar el mapa expandido cuando se hace clic fuera del mapa
  useEffect(() => {
    if (!isMapExpanded) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (mapRef.current && !mapRef.current.contains(event.target as Node)) {
        setIsMapExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMapExpanded]);

  // Evitar el scroll cuando el mapa está expandido
  useEffect(() => {
    if (isMapExpanded) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMapExpanded]);

  return (
    <footer className="relative mt-24">
      {/* Onda decorativa */}
      <div className="absolute inset-x-0 -top-10">
        <svg className="w-full" viewBox="0 0 1440 74" fill="none">
          <path
            d="M1440 74V39.6C1440 39.6 1082.89 0 720 0C357.109 0 0 39.6 0 39.6V74H1440Z"
            fill="#0A0A0B"
          />
        </svg>
      </div>

      <div className="bg-[#0A0A0B] pt-20 pb-12 relative">
        {/* Grid de fondo */}
        <div className="absolute inset-0 opacity-5">
          <div className="grid-background"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6">
          {/* Sección principal del footer */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
            {/* Logo, Contacto y Redes Sociales */}
            <div className="lg:col-span-4 space-y-8">
              <a
                href="/"
                className="inline-block cursor-pointer relative z-10 pointer-events-auto"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "/";
                }}
              >
                <img src={logoColor} alt="InnoTec" className="h-16 cursor-pointer" />
              </a>

              {/* Información de contacto */}
              <div className="space-y-4">
                <a
                  href="tel:+34622451145"
                  className="relative z-10 flex items-center gap-3 text-[#FCAA0D] font-bold text-xl hover:text-white transition-colors"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  (+34) 622 451 145
                </a>
                <a
                  href="tel:+34613222510"
                  className="relative z-10 flex items-center gap-3 text-[#FCAA0D] font-bold text-xl hover:text-white transition-colors"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  (+34) 613 222 510
                </a>
                <a
                  href="mailto:info@innotecfood.com"
                  className="relative z-10 flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  info@innotecfood.com
                </a>
              </div>

              {/* Horario */}
              <div className="bg-white/5 p-4 rounded-lg">
                <h4 className="text-[#FCAA0D] font-semibold mb-2">Horario de atención:</h4>
                <p className="text-gray-300 text-sm">
                  Lunes a Jueves: 8:00h a 14:00h y 15:00h a 17:00h
                </p>
                <p className="text-gray-300 text-sm">
                  Viernes: 8:00h a 14:30h
                </p>
              </div>

              {/* Redes Sociales */}
              <div>
                <h4 className="text-white font-semibold mb-3">Síguenos en redes sociales</h4>
                <div className="flex flex-wrap gap-3">
                  {socialLinks.map((social) => (
                    <a
                      key={social.name}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.name}
                      className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#FCAA0D] transition-all transform hover:scale-110"
                      title={social.name}
                    >
                      <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d={social.icon} />
                      </svg>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Sectores y Enlaces */}
            <div className="lg:col-span-3">
              <h3 className="text-lg font-bold mb-6 text-white">Servicios Destacados</h3>
              <ul className="space-y-3">
                <li>
                  <a
                    href="/servicios/b2b"
                    className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group cursor-pointer relative z-10 inline-block pointer-events-auto"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/servicios/b2b";
                    }}
                  >
                    <span className="text-[#FCAA0D] transform transition-transform group-hover:translate-x-1">
                      <svg
                        className="w-3 h-3"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                    Servicio B2B
                  </a>
                </li>
                <li>
                  <a
                    href="/servicios/plan-renove"
                    className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group cursor-pointer relative z-10 inline-block pointer-events-auto"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/servicios/plan-renove";
                    }}
                  >
                    <span className="text-[#FCAA0D] transform transition-transform group-hover:translate-x-1">
                      <svg
                        className="w-3 h-3"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                    Plan Renove
                  </a>
                </li>
                <li>
                  <a
                    href="/piensa-en-verde"
                    className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group cursor-pointer relative z-10 inline-block pointer-events-auto"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/piensa-en-verde";
                    }}
                  >
                    <span className="text-[#FCAA0D] transform transition-transform group-hover:translate-x-1">
                      <svg
                        className="w-3 h-3"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                    Piensa en Verde
                  </a>
                </li>
                <li>
                  <a
                    href="/trabaje-con-nosotros"
                    className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group cursor-pointer relative z-10 inline-block pointer-events-auto"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/trabaje-con-nosotros";
                    }}
                  >
                    <span className="text-[#FCAA0D] transform transition-transform group-hover:translate-x-1">
                      <svg
                        className="w-3 h-3"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                    Trabaja con Nosotros
                  </a>
                </li>
                <li>
                  <a
                    href="/visitanos"
                    className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group cursor-pointer relative z-10 inline-block pointer-events-auto"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/visitanos";
                    }}
                  >
                    <span className="text-[#FCAA0D] transform transition-transform group-hover:translate-x-1">
                      <svg
                        className="w-3 h-3"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                    Visítanos
                  </a>
                </li>
                <li>
                  <a
                    href="/maquinaria-usada"
                    className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group cursor-pointer relative z-10 inline-block pointer-events-auto"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/maquinaria-usada";
                    }}
                  >
                    <span className="text-[#FCAA0D] transform transition-transform group-hover:translate-x-1">
                      <svg
                        className="w-3 h-3"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                    Maquinaria Usada
                  </a>
                </li>
              </ul>
            </div>

            {/* Enlaces de Interés y Partners */}
            <div className="lg:col-span-2">
              <h3 className="text-lg font-bold mb-6 text-white">Enlaces de Interés</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-white transition-colors inline-block relative z-10 pointer-events-auto"
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href = link.href;
                      }}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>

              {/* Partners */}
              <div className="mt-8">
                <h3 className="text-lg font-bold mb-4 text-white">Colaborando con:</h3>
                <div className="bg-white/5 p-3 rounded-lg h-20 flex items-center">
                  <PartnerCarousel />
                </div>
              </div>
            </div>

            {/* Ubicaciones y Mapa */}
            <div className="lg:col-span-3">
              <h3 className="text-lg font-bold mb-6 text-white">Ubicaciones</h3>

              {/* Selector de ubicaciones */}
              <div className="flex flex-wrap gap-2 mb-4">
                {locations.map((location, index) => (
                  <div
                    key={index}
                    onClick={() => setActiveLocation(index)}
                    className={`relative z-10 cursor-pointer px-3 py-1 text-sm rounded-full transition-colors ${
                      activeLocation === index
                        ? "bg-[#FCAA0D] text-black font-medium"
                        : "bg-white/10 text-gray-300 hover:bg-white/20"
                    }`}
                  >
                    {location.name}
                  </div>
                ))}
              </div>

              {/* Información de la ubicación */}
              <div className="mb-4 p-4 bg-white/5 rounded-lg">
                <a
                  href={locations[activeLocation].mapUrl.replace('output=embed', 'output=svembed')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative z-10 block cursor-pointer transition-colors group"
                >
                  <p className="text-gray-300 group-hover:text-white">{locations[activeLocation].address}</p>
                  <p className="text-gray-300 group-hover:text-white">{locations[activeLocation].city}</p>
                </a>
                {locations[activeLocation].company && (
                  <p className="text-gray-300 mt-2 font-semibold">{locations[activeLocation].company}</p>
                )}
                {locations[activeLocation].phone && (
                  <a href={`tel:${locations[activeLocation].phone.replace(/\s/g, '')}`} className="relative z-10 block text-gray-300 mt-2 hover:text-white transition-colors">
                    {locations[activeLocation].phone}
                  </a>
                )}
              </div>

              {/* Mapa */}
              <div className="relative h-48 rounded-lg overflow-hidden group">
                <LocationMap
                  key={activeLocation}
                  mapUrl={locations[activeLocation].mapUrl}
                  title={`Mapa de ${locations[activeLocation].address}`}
                />

                {/* Botón de expandir mapa */}
                <button
                  className="absolute bottom-2 right-2 bg-[#FCAA0D] text-black p-2 rounded-md opacity-80 hover:opacity-100 transition-opacity duration-300 flex items-center gap-1 text-sm"
                  onClick={() => setIsMapExpanded(true)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5" />
                  </svg>
                  <span>Ampliar</span>
                </button>
              </div>
            </div>
          </div>

          {/* Separador */}
          <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent my-12" />

          {/* Enlaces Legales y Copyright */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-8">
            <div className="flex flex-wrap justify-center md:justify-start gap-6">
              {legalLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer relative z-10 inline-block pointer-events-auto"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = link.href;
                  }}
                >
                  {link.name}
                </a>
              ))}
            </div>
            <div className="text-sm text-gray-400 text-center md:text-right">
              <p className="mt-2">
                Copyright © {new Date().getFullYear()} Innotec Food Equipment. Todos los derechos reservados.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mapa expandido */}
      {isMapExpanded && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4 md:p-8">
          <div
            ref={mapRef}
            className="bg-[#0A0A0B] border border-[#FCAA0D]/20 rounded-xl overflow-hidden w-full max-w-4xl relative"
          >
            <div className="p-4 bg-[#FCAA0D]/10 flex justify-between items-center">
              <h3 className="text-white font-medium">{locations[activeLocation].address}</h3>
              <button
                className="text-white bg-white/10 hover:bg-white/20 p-2 rounded-full transition-colors"
                onClick={() => setIsMapExpanded(false)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="flex flex-col sm:flex-row">
              <div className="p-4 flex flex-col sm:w-1/3">
                <a
                  href={locations[activeLocation].mapUrl.replace('output=embed', 'output=svembed')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative z-10 block cursor-pointer transition-colors group"
                >
                  <p className="text-gray-300 text-sm mb-1 group-hover:text-white">{locations[activeLocation].address}</p>
                  <p className="text-gray-300 text-sm mb-4 group-hover:text-white">{locations[activeLocation].city}</p>
                </a>
                {locations[activeLocation].company && (
                  <p className="text-gray-300 text-sm font-semibold mb-4">{locations[activeLocation].company}</p>
                )}
                {locations[activeLocation].phone && (
                  <a href={`tel:${locations[activeLocation].phone.replace(/\s/g, '')}`} className="relative z-10 text-gray-300 text-sm hover:text-white transition-colors">
                    {locations[activeLocation].phone}
                  </a>
                )}
                <div className="mt-4">
                  <p className="text-white mb-2">Seleccionar sede:</p>
                  <div className="flex flex-wrap gap-2">
                    {locations.map((location, index) => (
                      <div
                        key={index}
                        onClick={() => setActiveLocation(index)}
                        className={`relative z-10 cursor-pointer px-3 py-1 text-sm rounded-full transition-colors ${
                          activeLocation === index
                            ? "bg-[#FCAA0D] text-black font-medium"
                            : "bg-white/10 text-gray-300 hover:bg-white/20"
                        }`}
                      >
                        {location.name}
                      </div>
                    ))}
                  </div>
                </div>
                <a
                  href={locations[activeLocation].mapUrl.replace('output=embed', 'output=svembed')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-auto bg-[#FCAA0D] text-black py-2 px-4 rounded text-center mt-4 hover:bg-[#FCAA0D]/90 transition-colors flex items-center justify-center gap-2"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                  <span>Abrir en Google Maps</span>
                </a>
              </div>
              <div className="sm:w-2/3 h-[300px] sm:h-auto">
                <LocationMap
                  key={activeLocation}
                  mapUrl={locations[activeLocation].mapUrl}
                  title={`Mapa de ${locations[activeLocation].address}`}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}

function PartnerCarousel() {
  const partners = [
    { src: mercyCorps, alt: "Mercy Corps" },
    { src: partnersInHealth, alt: "Partners in Health" },
    { src: wwf, alt: "WWF" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % partners.length);
    }, 3000); // Cambiar cada 3 segundos

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative h-full w-full">
      {partners.map((partner, index) => (
        <div
          key={partner.alt}
          className={`absolute inset-0 transition-opacity duration-1000 flex items-center justify-center ${
            index === currentIndex ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={partner.src}
            alt={partner.alt}
            className="h-12 object-contain"
          />
        </div>
      ))}
    </div>
  );
}
